export const AUTH_LOADING = 'AUTH_LOADING';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const AUTH_FAILED = 'AUTH_FAILED';
export const LOGOUT = 'LOGOUT';
export const ACTION_LOADING = 'ACTION_LOADING';
export const CREATE_LOAN = 'CREATE_LOAN';
export const NOT_LOADING = 'NOT_LOADING';
export const FETCH_LOANS = 'FETCH_LOANS';
